import { useCallback, useState } from 'react';

export const useEntitiesState = <T>(): [
  T[],
  number,
  boolean,
  (e: T[], t: number, l: boolean) => void
] => {
  const [entities, setEntities] = useState<T[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const setState = useCallback(
    (entities: T[], total: number, isLoading: boolean) => {
      setEntities(entities);
      setTotal(total);
      setIsLoading(isLoading);
    },
    []
  );

  return [entities, total, isLoading, setState];
};
